import { create } from "@/modules/core/store"
import type { TemplateCategoryEntity } from "@/modules/template/entities/templateCategoryEntity"

type TemplateFormDraft = {
  name: string
  description: string | null
  category: TemplateCategoryEntity | null
}

type TemplateFormDraftState = {
  drafts: Record<string, TemplateFormDraft>
  actions: {
    setDraft: (templateId: string, draft: TemplateFormDraft) => void
    clearDraft: (templateId: string) => void
  }
}

const useTemplateFormDraftStore = create<TemplateFormDraftState>()((set) => ({
  drafts: {},
  actions: {
    setDraft: (templateId, draft) => {
      set((state) => ({ drafts: { ...state.drafts, [templateId]: draft } }))
    },
    clearDraft: (templateId) => {
      set((state) => {
        const { [templateId]: _removed, ...rest } = state.drafts
        return { drafts: rest }
      })
    },
  },
}))

export const getTemplateFormDraft = (templateId: string): TemplateFormDraft | undefined =>
  useTemplateFormDraftStore.getState().drafts[templateId]

export const useTemplateFormDraftActions = () => useTemplateFormDraftStore((state) => state.actions)
